<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
export default {
  props: {
    buffer: {},
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    const cnvs = this.$refs.canvas;
    cnvs.width = this.width;
    cnvs.height = this.height;
    const imgData = new ImageData(
      new Uint8ClampedArray(this.buffer),
      this.width,
      this.height
    );
    cnvs.getContext("2d").putImageData(imgData, 0, 0);
  },
};
</script>

<style></style>
